/* KATSHU™ — motor de movimiento (ligero, vanilla, sin librerías)
   - reveals on scroll (IntersectionObserver)
   - parallax sutil (rAF, solo desktop y sin reduce-motion)
   - sticky editorial: panel activo por scroll
*/
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;

  /* ---- reveals ---- */
  function initReveals(){
    var els = document.querySelectorAll('.kt-reveal, .kt-mask');
    if(!('IntersectionObserver' in window) || reduce){
      els.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function(el){ io.observe(el); });
  }

  /* ---- parallax sutil (data-kt-parallax="0.12") ---- */
  function initParallax(){
    if(reduce || isTouch) return;
    var nodes = [].slice.call(document.querySelectorAll('[data-kt-parallax]'));
    if(!nodes.length) return;
    var ticking = false;
    function update(){
      var vh = window.innerHeight;
      nodes.forEach(function(n){
        var r = n.getBoundingClientRect();
        if(r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(n.getAttribute('data-kt-parallax')) || 0.1;
        var centerΔ = (r.top + r.height/2) - vh/2;
        n.style.transform = 'translate3d(0,' + (-centerΔ * speed).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
    update();
  }

  /* ---- hero scale-out on scroll (cinematic settle) ---- */
  function initHero(){
    if(reduce) return;
    var media = document.querySelector('.kt-hero__media img, .kt-hero__media video');
    if(!media) return;
    var hero = document.querySelector('.kt-hero');
    var ticking=false;
    function update(){
      var r = hero.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -r.top / (r.height||1)));
      media.style.transform = 'scale(' + (1.06 - p*0.06).toFixed(3) + ')';
      media.style.opacity = (1 - p*0.35).toFixed(3);
      ticking=false;
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update);} }
    window.addEventListener('scroll', onScroll, { passive:true });
    update();
  }

  /* ---- sticky editorial active panel ---- */
  function initSticky(){
    var groups = document.querySelectorAll('[data-kt-sticky]');
    if(!groups.length || !('IntersectionObserver' in window)) return;
    groups.forEach(function(group){
      var panels = group.querySelectorAll('[data-kt-panel]');
      var visual = group.querySelector('[data-kt-visual-index]');
      var frames = group.querySelectorAll('[data-kt-frame]');
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            var i = e.target.getAttribute('data-kt-panel');
            panels.forEach(function(p){ p.classList.toggle('is-active', p===e.target); });
            if(frames.length){
              frames.forEach(function(f){ f.classList.toggle('is-active', f.getAttribute('data-kt-frame')===i); });
            }
            if(visual) visual.setAttribute('data-kt-visual-index', i);
          }
        });
      }, { threshold: 0.6, rootMargin:'-20% 0px -20% 0px' });
      panels.forEach(function(p){ io.observe(p); });
    });
  }

  /* ---- measure sticky header, expose --kt-header-h ---- */
  function initHeaderVar(){
    var header = document.querySelector('header.shopify-section, .shopify-section-group-header-group header, header');
    function set(){
      if(!header) return;
      var h = Math.round(header.getBoundingClientRect().height);
      if(h>0 && h<400) document.documentElement.style.setProperty('--kt-header-h', h+'px');
    }
    set();
    window.addEventListener('resize', set, { passive:true });
    if('ResizeObserver' in window && header){ new ResizeObserver(set).observe(header); }
  }

  /* ---- scroll cue clicable: baja a la siguiente sección ---- */
  function initScrollCue(){
    var cue=document.querySelector('.kt-hero__scrollcue');
    if(!cue) return;
    cue.setAttribute('role','button');
    cue.setAttribute('tabindex','0');
    cue.setAttribute('aria-label','Desliza para descubrir');
    function go(){
      var hero=document.querySelector('.kt-hero');
      var target = hero ? (hero.getBoundingClientRect().bottom + window.scrollY - 1) : window.innerHeight;
      window.scrollTo({ top: target, behavior:'smooth' });
    }
    cue.addEventListener('click', go);
    cue.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); go(); } });
  }

  function boot(){ initHeaderVar(); initReveals(); initParallax(); initHero(); initSticky(); initScrollCue(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
